module.exports = __webpack_public_path__ + "static/media/2037DBD2-E47B-4732-B82E-FB6C9338ACE5_Small.b167d20d.jpg";